import { PressRelease } from "@tiicker/util/lib/contentful/types";
import { EntryCollection } from "contentful";
import React from "react";
import FeaturedNewsCard from "./FeaturedNewsCard";
import styles from "./FeaturedNewsSection.module.scss";

type Props = {
  news: EntryCollection<PressRelease>;
};

const FeaturedNewsSection = (props: Props) => {
  return (
    <div className={styles.container}>
      {props.news.items.map((news) => (
        <FeaturedNewsCard
          title={news.fields.title}
          date={news.fields.publishedDate}
          description={news.fields.description}
          slug={news.fields.slug}
          className={styles.newsCard}
          publicationLogo={news.fields.publicationLogo?.fields.file.url}
        />
      ))}
    </div>
  );
};

export default FeaturedNewsSection;
